import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { ButtonModule } from '@psei/ng/button';
import { PipesModule } from 'projects/ppb-shared-library/src/lib/pipes/pipes.module';
import { PseiNgCustomModule } from 'projects/ppb-shared-library/src/lib/psei-ng-custom.module';
import { PpbPmUserPermissionsEditComponent } from '../ppb-users/ppb-permission-management/ppb-pm-user-permissions-edit/ppb-pm-user-permissions-edit.component';
import { PpbLangSelectComponent } from './components/ppb-lang-select/ppb-lang-select.component';
import { PpbStartContainerComponent } from './components/ppb-start-container/ppb-start-container.component';


@NgModule({
    imports: [CommonModule, FlexModule, PipesModule, PseiNgCustomModule, ButtonModule],
  exports: [PipesModule, PpbStartContainerComponent, PpbPmUserPermissionsEditComponent, PpbLangSelectComponent],
  declarations: [PpbStartContainerComponent, PpbPmUserPermissionsEditComponent, PpbLangSelectComponent],
})
export class PpbShareModule {
}
